import UserAvatar from '@/components/common/auth/UserAvatar';
import PaletteIcon from '@mui/icons-material/Palette';
import { IconButton, Popover } from '@mui/material';
import { Stack } from '@mui/system';
import { useState, type FC } from 'react';
import ThemeManager from '../common/theme/ThemeManager';

const NavBarActions: FC = () => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  return (
    <Stack direction='row' gap={1} ml={6}>
      <IconButton sx={{ ml: 1 }} onClick={(e) => setAnchorEl(e.currentTarget)} color='inherit' size='small'>
        <PaletteIcon />
      </IconButton>
      <Popover
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
      >
        <ThemeManager />
      </Popover>
      <UserAvatar />
    </Stack>
  );
};

export default NavBarActions;
